import script from "./BaseShapeElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseShapeElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseShapeElement.vue?vue&type=style&index=0&id=073084bf&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-073084bf"]])

export default __exports__